import React from 'react';
import PropTypes from 'prop-types';
import LoginContainer from './LoginContainer';
import LoginWorkflow from './LoginWorkflow';

const LoginNakedContainer = ({
	onLoginSuccess,
	onBeforeSocialLogin,
	contextUsage,
	...props
}) => (
	<LoginContainer onLoginSuccess={onLoginSuccess} onBeforeSocialLogin={onBeforeSocialLogin} contextUsage={contextUsage}>
		{sharedProps => <LoginWorkflow {...sharedProps} {...props} />}
	</LoginContainer>
);

LoginNakedContainer.propTypes = {
	onBeforeSocialLogin: PropTypes.func,
	onLoginSuccess: PropTypes.func,
	contextUsage: PropTypes.string,
};

export default LoginNakedContainer;
